import { useState } from 'react';
import {
	basDeviceNetworkConfigurationPageKeys,
	guidedSectionMapping,
} from '../../const';
import { CongratsTemplate } from '../../CommonTemplates';
import BASDeviceNetworkConfiguration from './BASDeviceNetworkConfiguration';
import BASRequestPortAccess from './BASRequestPortAccess';
import { useSelector, useDispatch } from 'react-redux';
import { updateSectionStatusThunk } from '../../../../../redux/inputSheet/inputSheetSlice';

const DeviceNetworkConfigurationOnboarding = ({ onClose, setShowSnackbar }) => {
	const [pageNumber, setPageNumber] = useState(0);

	const networkConfigurationPages = {
		[basDeviceNetworkConfigurationPageKeys.DEVICE_NETWORK_CONFIGURATION]: (
			<BASDeviceNetworkConfiguration
				setShowSnackbar={setShowSnackbar}
				setPageNumber={setPageNumber}
			/>
		),
		[basDeviceNetworkConfigurationPageKeys.REQUEST_PORT_ACCESS]: (
			<BASRequestPortAccess
				setShowSnackbar={setShowSnackbar}
				setPageNumber={setPageNumber}
			/>
		),
		[basDeviceNetworkConfigurationPageKeys.SUCCESS]: (
			<DeviceNetworkConfigurationSuccess onClose={onClose} />
		),
	};

	return <>{networkConfigurationPages[pageNumber]}</>;
};

function DeviceNetworkConfigurationSuccess({ onClose }) {
	const dispatch = useDispatch();
	const propertyId = useSelector((state) => state.selectedBuilding.prop_id);

	const handleClose = () => {
		dispatch(
			updateSectionStatusThunk({
				propertyId,
				data: {
					[guidedSectionMapping['Device Network Configuration'].key]: {
						isComplete: true,
						isStarted: true,
						section_id:
							guidedSectionMapping['Device Network Configuration'].section_id,
					},
				},
			})
		);
		onClose();
	};
	return (
		<CongratsTemplate
			title="Thank you!"
			message="Your information has been saved successfully."
			onClick={handleClose}
		/>
	);
}

export default DeviceNetworkConfigurationOnboarding;
